module.exports = __webpack_public_path__ + "img/04_preview.2abe079f.png";